import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searchUsers, clearSearchResults } from "../redux/user/userAction"; // Ensure correct import path
import { useNavigate, useLocation, Link, useNavigation } from "react-router-dom";
import { IoChatbubbleEllipses, IoNotifications } from "react-icons/io5";
import profileImage from "../assests/defaultImage.png";
import { FaBookmark, FaCog, FaPlayCircle, FaSignOutAlt, FaSortDown, FaSortUp, FaUserFriends } from "react-icons/fa";
import Notification from "./DropDown/notificationDrop";
import Dropnav from "./DropDown/drooNav";
import FriendRequest from "./DropDown/friend";
// import Modal from "react-modal";
import { Icon } from "@iconify/react";
import { searchAndSortUser } from "../helper";
import { UserSearchLoader } from "./SkeletonLoaders";
import ClickOutsideWrapper from "./ModalComponents/ClickOutsideWrapper";
import { ClipLoader } from 'react-spinners';
import { getNotification } from "../redux/notification/notificationAction";
import { getFilteredQuery } from "../utils/search";
import { FaBars } from "react-icons/fa6";
import { toast } from "react-toastify";
import { logout } from "../redux/auth/authAction";
import { BiSolidPhotoAlbum } from "react-icons/bi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { MdGroups } from "react-icons/md";
import { IoWalletSharp } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import { SiStorybook } from "react-icons/si";
import { DRAFT_KEY } from "../constant";
import { useSocket } from "../hooks/useSocket";
import { clearSyncTimestamp } from "../helper/utilsFunctions";
import { useQueryClient } from "@tanstack/react-query";
import { getPendingFriendRequests } from "../redux/friend/friendAction"; // Adjust path as needed

const SearchBar = ({ endSearching }) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const isNavigating = navigation.state === 'loading';
  const [searchIsFocus, setSearchIsFocus] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const searchQueryValue = useRef('');
  const { searchLoading, searchHistory, userData } = useSelector((state) => state.user);
  const myId = userData.userId;

  const filteredQuery = getFilteredQuery(searchQuery);
  const sortedData = searchAndSortUser(filteredQuery, searchHistory) || [];

  // Handle search logic with debounce
  useEffect(() => {
    const handleSearch = async () => {
      try {
        const query = searchQuery;
        const lowerQuery = query.toLowerCase();
        if (lowerQuery === "bd@") return;

        if (lowerQuery.startsWith("bd@")) {
          const subQuery = query.substring(3);
          if (!subQuery) return;
          dispatch(searchUsers({ searchQuery: subQuery }));
        } else {
          dispatch(searchUsers({ searchQuery }));
        }
      } catch (error) {
        console.error("Search failed:", error.message);
      }
    };

    const delaySearch = setTimeout(() => {
      if (searchQuery.trim() !== "") {
        handleSearch();
      } else {
        dispatch(clearSearchResults());
      }
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchQuery, dispatch]);

  useEffect(() => {
    if (!isNavigating && searchQueryValue.current) {
      setSearchQuery('');
      endSearching?.()
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNavigating]);

  return (
    <div className="flex items-center relative w-full z-[100] max-w-lg">
      <input name="search"
        onChange={(e) => {
          setSearchQuery(e.target.value);
          searchQueryValue.current = e.target.value
        }} value={searchQuery}
        type="text" placeholder="search"
        onFocus={() => setSearchIsFocus(true)} disabled={isNavigating}
        className="search-bar-style inline-flex  p-2 w-full items-center bg-customGray text-white placeholder-white flex-shrink rounded-lg focus:outline-none focus:ring-2 focus:ring-customGold" />

      {/* Loader */}
      {isNavigating && searchQuery && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2">
          <ClipLoader color="#BE9524" height={16} width={16} />
        </div>
      )}

      {/* Dropdown */}
      {searchIsFocus && (
        <ClickOutsideWrapper
          onClose={() => setSearchIsFocus(false)}
          ignoreSelector="search-bar-style"
          className={`absolute  w-full bg-customDark text-white rounded-lg shadow-lg overflow-y-auto top-full h-80 mt-2`}
        >
          {/* Results */}
          {searchQuery && sortedData.length > 0 ? (
            sortedData.map((user) => (
              <Link
                key={user.userId}
                to={user.userId === myId ? "/profile" : `/user/${user.userId}`}
                onClick={() => setSearchIsFocus(false)}
                className="flex items-center p-3 hover:bg-gray-800 cursor-pointer transition w-full"
              >
                <img
                  src={user.profilePhoto[0]?.photoPublicUrl || profileImage}
                  alt="Profile"
                  className="w-12 h-12 rounded-full object-cover"
                />
                <span className="ml-3 flex flex-col w-full">
                  <span className="font-bold text-[12px] hover:text-gray-400 transition duration-200 line-clamp-1">
                    {user.firstName} {user.lastName}
                  </span>
                  {user.userName && (
                    <span className="text-[10px] text-gray-400">BD@{user.userName}</span>
                  )}
                </span>
              </Link>
            ))
          ) : searchLoading ? (
            <>
              <UserSearchLoader />
              <UserSearchLoader />
            </>
          ) : searchQuery && sortedData.length === 0 ? (
            <div className="flex flex-col items-center justify-center text-center py-6 px-4 text-white rounded-xl shadow-md">
              <div className="text-[12px]">
                {searchQuery.toLowerCase() === "bd@" ? "🔍" : "😕"}
              </div>
              {searchQuery.toLowerCase() !== "bd@" && (
                <h2 className="text-xl font-semibold mb-2">No Results Found</h2>
              )}
              <p className="text-gray-400 text-sm max-w-md">
                {searchQuery.toLowerCase() !== "bd@" && (
                  <>
                    We couldn't find any users matching{" "}
                    <span className="text-customGold font-medium">
                      "{searchQuery}"
                    </span>
                  </>
                )}
                <br />
                {searchQuery.toLowerCase() === "bd@" ? (
                  <>
                    Try typing a name or username after{" "}
                    <span className="text-customGold font-semibold">"bd@"</span>
                  </>
                ) : (
                  <>Please check the spelling or try a different name.</>
                )}
              </p>
            </div>
          ) : (
            !searchQuery &&
            !searchLoading && (
              <div className="flex flex-col items-center justify-center text-center py-6 px-4 text-white rounded-xl shadow-md">
                <div className="text-5xl mb-4">🔍</div>
                <h2 className="text-xl font-semibold mb-2">Start Searching</h2>
                <p className="text-gray-400 text-sm max-w-md">
                  Enter a name or username in the search bar to find a user.
                </p>
              </div>
            )
          )}
        </ClickOutsideWrapper>
      )}
    </div>

  );
};






const ChatIcon = ({ chatActive }) => {
  const navigate = useNavigate();
  const chatList = useSelector(state => state.chat.chatList);
  const hasUnread = [...chatList].some(item => Number(item?.unreadCount) > 0)
  //   const totalUnread = chatList.reduce((acc, item) => {
  //   return acc + Number(item?.unreadCount || 0);
  // }, 0);


  return (
    <button title="Chats" onClick={() => navigate('/chat')} className="relative">
      <IoChatbubbleEllipses size={24} className={`hover:opacity-80 hover:scale-105 transition duration-100 ${chatActive ? 'text-customGold' : ''}`} />
      {hasUnread && (
        <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full"></span>
      )}
    </button>
  )
}




const NotificationPanelIcon = () => {
  const [isNotification, setIsNotification] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.user);
  const { notifications, loading } = useSelector(state => state.notifications);
  const unReadNotifications = notifications.filter(item => item.read === false);
  const isLoaded = useRef("unloaded");

  useEffect(() => {
    if (userData && userData.userId && isLoaded.current === 'unloaded') {
      dispatch(getNotification());
      isLoaded.current = 'loaded';
    }
  }, [userData, dispatch]);

  const isMobile = () => window.innerWidth < 768; // md breakpoint

  const handleNotificationClick = useCallback(() => {
    if (isMobile()) {
      navigate('/notifications');
    } else {
      setIsNotification(prev => !prev);
    }
  }, [navigate]);

  return (
    <div
      className={`${isNotification ? 'text-customGold' : ''} relative`}
    >
      <IoNotifications
        title="Notifications"
        className="click-notification hover:opacity-80 cursor-pointer hover:scale-105 transition duration-100"
        size={24}
        onClick={handleNotificationClick}
      />
      {isNotification && !isMobile() &&
        <ClickOutsideWrapper onClose={() => setIsNotification(false)} ignoreSelector={"click-notification"} className="absolute">
          <Notification
            onClose={() => setIsNotification(false)}
            notifications={notifications}
            unReadNotifications={unReadNotifications}
            loading={loading}
          />
        </ClickOutsideWrapper>
      }
      {!isNotification && unReadNotifications?.length > 0 && (
        <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full"></span>
      )}
    </div>
  );
};


export default function Navbar() {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const { socket } = useSocket();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(""); // keep track of active tab
  const { userData } = useSelector((state) => state.user);


  const menuItems = [
    { label: "Find Friends", icon: <FaUserFriends />, path: "/friends" },
    { label: "Flips", icon: <FaPlayCircle />, path: "/flips" },
    { label: "Groups", icon: <MdGroups />, path: "/group" },
    { label: "Naray8", icon: <SiStorybook />, path: "/naray8" },
    { label: "Albums", icon: <BiSolidPhotoAlbum />, path: "/album" },
    { label: "Events", icon: <FontAwesomeIcon icon={faCalendarAlt} />, path: "/events" },
    { label: "Saved Posts", icon: <FaBookmark />, path: "/savepost" },
    { label: "Wallet", icon: <IoWalletSharp />, path: "/wallet" },
    { label: "Settings", icon: <FaCog />, path: "/setting" },


  ];

  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isFriend, setIsFriend] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // Handled requests (accepted/declined/etc.) stay in the list briefly so
  // the user can correct a misclick, so only count still-pending ones here.
  const pendingRequestsCount = useSelector((state) =>
    state.friend.friendRequests?.filter((request) => !request.requestStatus || request.requestStatus === 'pending').length || 0
  );


  useEffect(() => {
    dispatch(getPendingFriendRequests(userData.userId))
  }, [userData?.userId, dispatch]);

  const handleLogout = async () => {
    try {
      const isSuccessfulLoggout = await dispatch(logout(socket.id)).unwrap()
      localStorage.removeItem(DRAFT_KEY);
      clearSyncTimestamp()
      if (isSuccessfulLoggout) {
        queryClient.resetQueries();
        queryClient.clear();
        dispatch({ type: 'RESET_STORE' })
      }
    } catch (error) {
      toast.error(error.message)
    }
  }
  const profilePhotoUrl = useSelector((state) => state.user.profilePhotoUrl);
  // const [hasFriendRequests, setHasFriendRequests] = useState(false);

  // ---------------------------------------------------------------------------------------------------------------

  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const element = event.target;

      const isButtonClick = element.closest('button') !== null;
      const isInsideFriendCon = element.closest(".friend-con") !== null;
      const isOnFriendClick = element.closest(".friend-click") !== null;
      if (!isInsideFriendCon && !isOnFriendClick && !isButtonClick) {
        setIsFriend(false);
      }
    }

    if (isFriend) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFriend]);

  // -------------------------------------------------------------------------------------------------------

  const navImage = profilePhotoUrl || profileImage;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleFriend = () => {
    setIsFriend(!isFriend);
  };

  const isHomeActive = location.pathname === "/";
  const chatActive = location.pathname === '/chat'

  // ADD THIS NEW STATE AT THE TOP WITH YOUR OTHER STATES
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const mobileSearchRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (mobileSearchRef.current && !mobileSearchRef.current.contains(e.target)) {
        setIsMobileSearchOpen(false);
      }
    }

    if (isMobileSearchOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileSearchOpen]);


  // Helper component for Chat badge in mobile menu
  const MobileChatBadge = () => {
    const chatList = useSelector(state => state.chat.chatList);
    const hasUnread = [...chatList].some(item => Number(item?.unreadCount) > 0);

    if (!hasUnread) return null;

    return (
      <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-red-500 rounded-full ring-2 ring-black animate-pulse"></span>
    );
  };

  // Helper component for Notifications badge in mobile menu
  const MobileNotificationBadge = () => {
    const { notifications } = useSelector(state => state.notifications);
    const hasUnread = notifications.some(item => item.read === false);

    if (!hasUnread) return null;

    return (
      <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-red-500 rounded-full ring-2 ring-black animate-pulse"></span>
    );
  };

  // Helper component for Friends badge in mobile menu
  const MobileFriendsBadge = ({ count }) => {
    if (!count || count === 0) return null;

    return (
      <span className="absolute -top-2 -right-2 w-3 h-3 bg-red-500 rounded-full ring-2 ring-black"></span>
    );
  };

  return (
    <div className="fixed top-0 z-50 w-full bg-black h-16 flex items-center px-2 sm:px-4 md:px-6 lg:px-8 justify-between">

      {/* LEFT SECTION */}
      <div className="flex items-center md:gap-4 md:w-[40%]">

        <button
          onClick={() => navigate('/')}
          className="flex gap-2 md:gap-4 items-center flex-shrink-0"
        >
          <img
            className="w-9 h-9 md:w-10 md:h-10 hover:opacity-80 hover:scale-105 transition"
            src="/assests/bdlogoimage.png"
            alt="logo"
          />
          <h1 className="uppercase text-white text-sm font-sans-Bliar-ITC hover:opacity-80 hover:scale-105 transition">
            Blackdefynition
          </h1>
        </button>
        <div className="hidden md:flex flex-1">
          <SearchBar />
        </div>

      </div>


      <div
        title="Home"
        className={`flex justify-center items-center cursor-pointer mx-4 sm:mx-[40px] sm:mr-4 md:w-7 sm:h-7 flex-1 rounded-xl hover:scale-105 duration-100 transition ${isHomeActive ? 'text-customGold' : 'text-white'}`}
      >
        <Icon
          onClick={() => navigate('/')}
          icon="material-symbols:home"
          className="w-[35px] text-3xl lg:text-4xl"
        />

        <div className="md:hidden relative">
          <button onClick={() => setOpen(!open)} className="text-white mt-2">
            {open ? (
              <FaSortDown size={20} className="text-customGold" />
            ) : (
              <FaSortUp size={20} />
            )}
          </button>
        </div>
      </div>


      {/* CENTER DROPDOWN MENU FOR MOBILE */}
      <div className="sm:hidden relative">
        {open && (
          <div className="fixed inset-0 z-40 md:hidden">
            <div
              className="absolute inset-0 bg-black/50"
              onClick={() => setOpen(false)}
            />
            <div className="absolute top-12 left-1/2 -translate-x-1/2 bg-[#1C1B19] text-white rounded-xl shadow-lg p-2 w-48 z-50">
              {menuItems.map((item) => (
                <div
                  key={item.label}
                  onClick={() => {
                    setActiveTab(item.label);
                    navigate(item.path);
                    setOpen(false);
                  }}
                  className={`flex items-center gap-2 p-2 rounded cursor-pointer
                  ${activeTab === item.label
                      ? "bg-yellow-500 text-black"
                      : "hover:bg-red-500 hover:text-black"
                    }
                `}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>


      {/* RIGHT SECTION (DESKTOP ONLY) */}
      <div className="hidden md:flex justify-end items-center flex-grow w-[40%] gap-9">
        <ChatIcon chatActive={chatActive} />

        {/* Desktop Friend button */}
        <div className="relative">
          <button
            title="Friend Requests"
            className="friend-click relative"
            onClick={toggleFriend}
          >
            <FaUserFriends
              size={24}
              className={`hover:opacity-80 hover:scale-105 transition ${isFriend ? 'text-customGold' : ''
                }`}
            />
            {pendingRequestsCount > 0 && (
              <span className="absolute -top-2 -right-2 w-3 h-3 bg-red-500 rounded-full ring-2 ring-black"></span>
            )}
          </button>

          {isFriend && (
            <FriendRequest  />
          )}
        </div>

        <NotificationPanelIcon />

        <button onClick={() => navigate('/profile')}>
          <img
            title="Profile"
            className="rounded-full w-10 h-10 hover:opacity-80 hover:scale-105 transition"
            src={navImage}
            alt="profile"
          />
        </button>

        {/* Desktop Dropdown */}
        <div className="relative font-bold inline-block text-left">
          <button onClick={toggleMenu} className="dropdownbutton text-white">
            {isOpen ? (
              <FaSortUp size={30} className="text-customGold mt-6" />
            ) : (
              <FaSortDown size={30} />
            )}
          </button>

          {isOpen && (
            <ClickOutsideWrapper onClose={() => setIsOpen(false)} ignoreSelector="dropdownbutton" className="drop-down-click absolute top-[60px] right-0">
              <Dropnav onClose={() => setIsOpen(false)} />
            </ClickOutsideWrapper>
          )}
        </div>
      </div>


      <div className="md:hidden justify-end flex items-center gap-3 sm:gap-4 md:gap-5">


        <button onClick={() => setIsMobileSearchOpen(true)} className="text-white text-lg">
          <FaSearch />
        </button>

        <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <FaBars className="text-white text-lg w-7" />
        </button>
      </div>


      {/* MOBILE MENU OVERLAY */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-md"
            onClick={() => setIsMenuOpen(false)}
          />

          <div
            ref={menuRef}
            className="relative bg-gradient-to-br from-[#1C1B19] via-[#2a2722] to-black rounded-3xl shadow-2xl p-8 w-[90%] max-w-md z-50"
          >
            <h2 className="text-center text-xl font-semibold text-[#BE9524] mb-6">Menu</h2>

            <div className="grid grid-cols-3 gap-6 text-center">
              <Link to="/" onClick={() => setIsMenuOpen(false)} className="flex flex-col items-center group">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#BE9524]/20 group-hover:bg-[#BE9524] transition">
                  <Icon icon="material-symbols:home" className="w-7 h-7 text-[#BE9524] group-hover:text-black" />
                </div>
                <span className="mt-2 text-sm text-white group-hover:text-[#BE9524]">Home</span>
              </Link>

              <Link to="/chat" onClick={() => setIsMenuOpen(false)} className="flex flex-col items-center group relative">
                <div className="relative">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#BE9524]/20 group-hover:bg-[#BE9524] transition">
                    <IoChatbubbleEllipses size={22} className="text-[#BE9524] group-hover:text-black" />
                  </div>
                  <MobileChatBadge />
                </div>
                <span className="mt-2 text-sm text-white group-hover:text-[#BE9524]">Chat</span>
              </Link>

              <Link to="/profile" onClick={() => setIsMenuOpen(false)} className="flex flex-col items-center group">
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[#BE9524] group-hover:scale-105 transition">
                  <img src={navImage} alt="Profile" className="w-full h-full object-cover" />
                </div>
                <span className="mt-2 text-sm text-white group-hover:text-[#BE9524]">Profile</span>
              </Link>

              <Link to="/friends" onClick={() => setIsMenuOpen(false)} className="flex flex-col items-center group relative">
                <div className="relative">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#BE9524]/20 group-hover:bg-[#BE9524] transition">
                    <FaUserFriends size={22} className="text-[#BE9524] group-hover:text-black" />
                  </div>
                  <MobileFriendsBadge count={pendingRequestsCount} />
                </div>
                <span className="mt-2 text-sm text-white group-hover:text-[#BE9524]">Friends</span>
              </Link>

              <Link to="/notifications" onClick={() => setIsMenuOpen(false)} className="flex flex-col items-center group relative">
                <div className="relative">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#BE9524]/20 group-hover:bg-[#BE9524] transition">
                    <IoNotifications size={22} className="text-[#BE9524] group-hover:text-black" />
                  </div>
                  <MobileNotificationBadge />
                </div>
                <span className="mt-2 text-sm text-white group-hover:text-[#BE9524]">Notifications</span>
              </Link>

              <div onClick={handleLogout} className="flex flex-col items-center group cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-red-500/20 group-hover:bg-red-600 transition">
                  <FaSignOutAlt size={22} className="text-red-500 group-hover:text-white" />
                </div>
                <span className="mt-2 text-sm text-white group-hover:text-red-500">Log Out</span>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* MOBILE SEARCH OVERLAY */}
      {isMobileSearchOpen && (
        <div className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden flex items-start justify-center pt-20">
          <div
            ref={mobileSearchRef}
            className="w-[90%] bg-[#1C1B19] p-4 rounded-xl shadow-xl"
          >
            {/* Mobile version of SearchBar */}
            <div className="w-full mt-4">
              <SearchBar isMobile={true} endSearching={() => {
                if (isMobileSearchOpen) {
                  setIsMobileSearchOpen(false)
                }
              }} />
            </div>
          </div>
        </div>
      )
      }


    </div >
  );

}